'use client';

import { useFormFields } from '@payloadcms/ui';
import Image from 'next/image';
import React from 'react';

const VideoPreview = () => {
  const field = useFormFields(([fields]) => {
    const data = fields;
    return {
      url: data?.url?.value as string | undefined,
      mimeType: data?.mimeType?.value as string | undefined,
      filename: data?.filename?.value as string | undefined,
    };
  });

  return (
    <div
      style={{
        marginTop: '1rem',
        marginBottom: '1rem',
      }}
    >
      <div style={{ marginBottom: '0.5rem' }}>
        <strong>Image Preview:</strong>
      </div>
      <Image src={field.url || ''} alt="Image preview" width={300} height={200} style={{ maxWidth: '100%', height: 'auto' }} />
    </div>
  );
};

export default VideoPreview;
